module.exports = __webpack_public_path__ + "static/usecase_wallet_profile@2x-ca6686492137c86807420787699a95b2.png";